import React, { useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { StudentRosterRow } from "../components/StudentRosterRow";
import { AddStudentModal } from "../components/AddStudentModal";
import { useRoster, useAddStudent } from "../hooks/useRoster";
import { useMarkAttendance } from "../hooks/useAttendance";

function AttendancePage() {
  const { slug, planningId } = useParams();
  const navigate = useNavigate();
  const [showAddStudent, setShowAddStudent] = useState(false);

  const { data: roster, isLoading, error } = useRoster(planningId);
  const markMutation = useMarkAttendance(planningId);
  const addStudentMutation = useAddStudent(planningId);

  const handleSetStatus = (entry, status) => {
    const student = entry.student ?? entry;
    if (status === entry.attendance_status) return; // no-op
    // "Ausente" puede descontar horas del paquete pasado el cupo de inasistencia
    // del estudiante — confirmar antes de marcarlo.
    if (
      status === false &&
      !window.confirm(
        `¿Marcar a ${student.name} como AUSENTE? Si supera su cupo de ` +
          `inasistencia, se descontarán horas de su paquete según la duración de la clase.`
      )
    ) {
      return;
    }
    markMutation.mutate({ student: student.id, status });
  };

  const handleAddStudent = (data) => {
    addStudentMutation.mutate(data, {
      onSuccess: () => setShowAddStudent(false),
    });
  };

  const presentCount = (roster ?? []).filter(
    (e) => e.attendance_status === true
  ).length;

  return (
    <>
      <div className="container-fluid px-3">
        <div className="py-3">
          <Link
            to={`/${slug}/app/agenda/${planningId}`}
            className="text-muted small d-block mb-2"
          >
            ← Detalle de clase
          </Link>
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="h4 mb-0">Asistencia</h1>
            <span className="text-muted small">
              {presentCount} / {(roster ?? []).length} presentes
            </span>
          </div>
        </div>

        {isLoading && (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" />
          </div>
        )}

        {error && (
          <Alert variant="danger">
            No se pudo cargar el roster de la clase.
          </Alert>
        )}

        {!isLoading && !error && (
          <>
            {(roster ?? []).length === 0 && (
              <p className="text-muted text-center py-4">
                No hay estudiantes inscritos en esta clase.
              </p>
            )}
            <div>
              {(roster ?? []).map((entry) => (
                <StudentRosterRow
                  key={entry.student?.id ?? entry.id}
                  entry={entry}
                  onSetStatus={handleSetStatus}
                  isLoading={markMutation.isPending}
                />
              ))}
            </div>

            <div className="py-3 d-flex flex-column gap-2">
              <Button
                variant="outline-secondary"
                onClick={() => setShowAddStudent(true)}
                style={{ minHeight: 44 }}
              >
                + Agregar estudiante no registrado
              </Button>
              <Button
                variant="primary"
                onClick={() =>
                  navigate(`/${slug}/app/agenda/${planningId}/grade-card`)
                }
                style={{ minHeight: 56 }}
              >
                Continuar → Grade card ({presentCount})
              </Button>
            </div>
          </>
        )}
      </div>

      <AddStudentModal
        show={showAddStudent}
        onHide={() => setShowAddStudent(false)}
        onAdd={handleAddStudent}
        isLoading={addStudentMutation.isPending}
        error={addStudentMutation.error}
      />
    </>
  );
}

export { AttendancePage };
